import { v4 as uuidv4 } from 'uuid';
import { restApi } from '@icp/settings';
import { parseJSON } from '@icp/utils';
import fetchSSE from '../AIAgent/fetchSSE';

export async function generateTokenByOriginalText(originalText) {
  try {
    if (!originalText) throw Error();
    const { token } = await restApi.post(
      `/aip/api/gpt/generate-token`,
      { content: originalText },
      { skipResponseInterceptors: true },
    );
    // 这个接口会返回字符串null，走兜底
    if (!token || token === 'null') throw Error();
    return token;
  } catch {
    // 兜底 短uuid
    return uuidv4().split('-')[0];
  }
}

export async function generateTranslation({ text, targetLanguage, callback }) {
  if (!text || !targetLanguage) return;
  let total = '';
  for await (const message of fetchSSE({
    url: `/aip/api/ai/translate`,
    body: JSON.stringify({
      text,
      targetLanguage,
    }),
  })) {
    total += parseJSON(message.data, { silent: true })?.content ?? '';
    callback(total);
  }
}
